import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Coordinates } from '../../../../../viewer/utilities/math-helpers';
import { useUnitSymbols } from '../../../../hooks/use-unit-symbols';
import { CoordinatePropertiesStyled } from './coordinate-properties';

export type AreaProps = {
  type: 'area';
  area: number;
  planeArea: number;
  circumference: number;
  length: number;
};

export const AreaProperties = (props: {
  coordinate: Coordinates;
  coordinateSystem?: string;
  properties: AreaProps;
}) => {
  const { t } = useTranslation();
  const unitSymbols = useUnitSymbols();

  return (
    <Component>
      <p className="area">
        <label>{t('assetPositionTooltip.areaProperties.surface3d', { ns: 'skyview' })}</label>
        <span>
          {props.properties.area > 0 ? (
            <>
              <span>{props.properties.area.toFixed(2)}</span> {unitSymbols.area}
            </>
          ) : (
            '-'
          )}
        </span>
      </p>

      <p className="plane-area">
        <label>{t('assetPositionTooltip.areaProperties.surface2d', { ns: 'skyview' })}</label>
        <span>
          {props.properties.planeArea > 0 ? (
            <>
              <span>{props.properties.planeArea.toFixed(2)}</span> {unitSymbols.area}
            </>
          ) : (
            '-'
          )}
        </span>
      </p>

      <p className="circumference">
        <label>{t('assetPositionTooltip.areaProperties.circumference', { ns: 'skyview' })}</label>
        <span>
          {props.properties.circumference > 0 ? (
            <>
              <span>{props.properties.circumference.toFixed(2)}</span> {unitSymbols.length}
            </>
          ) : (
            '-'
          )}
        </span>
      </p>

      <p className="plane-length">
        <label>{t('assetPositionTooltip.areaProperties.length2d', { ns: 'skyview' })}</label>
        <span>
          {props.properties.length > 0 ? (
            <>
              <span>{props.properties.length.toFixed(2)}</span> {unitSymbols.length}
            </>
          ) : (
            '-'
          )}
        </span>
      </p>
    </Component>
  );
};

const Component = styled(CoordinatePropertiesStyled)`
  grid-template-areas:
    'area               plane-area'
    'circumference      plane-length';

  .area {
    grid-area: area;
  }

  .plane-area {
    grid-area: plane-area;
  }

  .circumference {
    grid-area: circumference;
  }

  .plane-length {
    grid-area: plane-length;
  }
`;
